import "./config-types";
import { getEnvironment } from "./constant";

let environment = getEnvironment();

const configModule = require("./" + environment + ".js");

/**
 * @type {AppConfig}
 */
const appConfig = configModule.default;

// Re-export named exports (may not exist in all environments)
export const APP_ENV_CONFIG = configModule.APP_ENV_CONFIG;

export default appConfig;
